import { addItem, getItems, getItem } from './db';

let ConfigsTable = 'Configs';

export async function saveConfig(data) {
    await addItem(ConfigsTable, data, '_id');
}

export async function getLocalConfigs() {
    return await getItems(ConfigsTable);
}

export async function getConfig(key) {
    return await getItem(ConfigsTable, key);
}